import { Module } from 'vuex';

import { RootState } from 'frontend/types';

interface AuthorLessonChapter {
  chapter_name: string;
  course_name: string;
}

interface AuthorLesson {
  url: string;
  name: string;
  description: string;
  image_url: string;
  chapters: AuthorLessonChapter[];
}

interface AuthorLessonsState {
  authorLessons: AuthorLesson[];
}

const authorLessonsModule: Module<AuthorLessonsState, RootState> = {
  namespaced: true,
  state: {
    authorLessons: [],
  },

  mutations: {
    setValue(state: AuthorLessonsState, value: AuthorLesson[]) {
      state.authorLessons = value;
    },
  },
};

export default authorLessonsModule;
